import VsNotify from "./Notify.vue";
import { VueConstructor } from "vue";

export const Plugin = {
  install(
    //
    Vue: VueConstructor & {
      prototype: {
        $notify: ((group: string, text: string, { type, duration }: { type?: string; duration?: number }) => void) & { groups?: Record<string, any> };
      };
      component(componentName: string, vsNotify: typeof VsNotify): void;
    },
    { componentName = "vs-notify", defaultDuration = 1500, defaultErrorDuration = 3000 } = {}
  ) {
    Vue.prototype.$notify = (group: string, text: string, { type, duration }: { type?: string; duration?: number } = {}) => {
      if (!duration) {
        duration = type === "error" ? defaultErrorDuration : defaultDuration;
      }

      if (Vue.prototype.$notify.groups![group]) {
        Vue.prototype.$notify.groups![group](text, type, duration);
      }
    };

    Vue.prototype.$notify.groups = {};

    Vue.component(componentName, VsNotify);
  },
};

export default VsNotify;
